import { Button, Tooltip } from 'flowbite-react';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import UserApi from '../../Api/UserApi';
import { User } from '../../Models/User';
import { useAppSelector } from '../../Reducers/store';
import { HiPencilAlt } from 'react-icons/hi';

export default function UserProfile() {
  const { userModel } = useAppSelector((state) => state.user);
  const { id } = useParams();
  const [userData, setUserData] = useState<User | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getUser = () => {
    if (id) {
      setIsLoading(true);
      UserApi.getUser(id)
        .then((res) => {
          setUserData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setUserData(null);
    }
  };

  useEffect(() => {
    getUser();
  }, [id]);

  const iconstyle = { color: '#f9ed33' };

  function checkAccess() {
    if (userData && userModel && id) {
      return true;
      // if (userModel.userLevelId === UserLevelNames.SuperAdmin) {
      //   return true;
      // } else if (
      //   userModel.memberId === userData.memberId &&
      //   userModel.id === Number(id)
      // ) {
      //   return true;
      // } else if (
      //   userModel.memberId === userData.memberId &&
      //   userModel.userLevelId === UserLevelNames.MemberAdmin
      // ) {
      //   return true;
      // } else {
      //   return false;
      // }
    }
    return false;
  }

  return (
    <div className='w-full'>
      <div className='w-full p-4'>
        <div className='mx-1 flex items-end'>
          <div className='flex flex-1'>
            <h1 className='text-gray-900 font-bold text-4xl'>
              User Information
            </h1>
          </div>
          {checkAccess() && (
            <div className='right-2'>
              <Link to={`/edit/user/${userData?.id}`}>
                <Tooltip content='Edit'>
                  <Button className='buttonMain'>
                    <HiPencilAlt size={20} />
                  </Button>
                </Tooltip>
              </Link>
            </div>
          )}
        </div>
      </div>

      <div>
        <div className='container mx-auto p-2'>
          <div className='md:flex no-wrap md:-mx-2 '>
            {/* <div className='w-full md:w-2/12 md:mx-2'>
              <div className='h-72 overflow-hidden rounded-md'>
                <img src={userData?.image?.url ?? blankImage} alt='...' />
              </div>
            </div> */}
            <div className='w-full mx-2'>
              <div className='bg-white p-3'>
                <div className='flex items-center space-x-2 font-bold text-gray-500 leading-8 py-2'>
                  <span className='tracking-wide uppercase text-3xl'>
                    {userData?.firstName} {userData?.lastName}
                  </span>
                </div>
                <hr className='bg-gray-300 h-[5px]'></hr>
                <div className='text-gray-500'>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Client:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {userData?.client?.name ?? ''}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Email:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {userData?.emailAddress}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Phone:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {userData?.phoneNumber &&
                        '(' +
                          userData?.phoneNumber
                            .replace(/[^0-9]+/g, '')
                            .slice(0, 3) +
                          ') ' +
                          userData?.phoneNumber
                            .replace(/[^0-9]+/g, '')
                            .slice(3, 6) +
                          '-' +
                          userData?.phoneNumber
                            .replace(/[^0-9]+/g, '')
                            .slice(6)}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>

                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>User Level:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {userData?.userLevel?.name}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Bio:</div>
                    </div>
                    <div className='pl-1 text-black'>{userData?.bio}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
